// Any rAFs queued in your event handlers will be executed in the same frame.
// Any rAFs queued in a rAF will be executed in the next frame.
export const nextFrame = (fn: () => void) =>
  requestAnimationFrame(() => {
    requestAnimationFrame(fn);
  });
